import React, { useEffect, useRef, useState } from "react"
import Body from "../../components/body/BodyPage"
import MainLinks from "../../components/navlinks/MainLinks"
import { useTranslation } from "react-i18next";
import { MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBSpinner, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane } from "mdb-react-ui-kit";
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router";
import { getMisc, getPhoneNumberRemediationData, updatePhoneNumberRemediation } from "../../apiclients/streamsapi_bridge";
import TopSuccess from "../../components/header/TopSuccess";
import TopMessage from "../../components/header/TopMessage";
import { AddRemoveNumbers, formattedNumber, unFormatNumber } from "../popups/phonenumbers/AddRemoveNumbers";
import PopupLoaderNew from "../popups/PopupLoaderNew";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";

function ReputationLanding(props) {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [basicActive, setBasicActive] = useState('tab1');
    const [reputationInfo, setreputationInfo] = useState([]);
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorResponse, seterrorResponse] = useState("");
    const [existingNumbers, setexistingNumbers] = useState([]);
    const [assignPhNum, setAssignPhNum] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [addNumbers, setaddNumbers] = useState(false);
    const [assignExecuted, setAssignExecuted] = useState(false);
    const [sourceNumber, setSourceNumber] = useState([]);
    const [isreRender, setisreRender] = useState(false);

    // Delete confirmation modal states
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteNumberList, setdeleteNumberList] = useState([]);
    const [imageUrl, setimageUrl] = useState([]);
    const [flagService, setflagService] = useState([]);
    const [basicModal, setBasicModal] = useState(false);

    const addNumberRef = useRef(null);
    const deleteRef = useRef(null);

    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [rowdata, setRowData] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(!isloading,setDataLoaded,searchRef,props.isActive)
    // Toggle functions
    const togglePopup = () => setaddNumbers(!addNumbers);
    const toggleDeleteModal = () => setShowDeleteModal(!showDeleteModal);
    const toggleOpen = () => setBasicModal(!basicModal);

    function handleClick() {
        addNumberRef.current.click();
    }

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    function handleDeleteClick() {
        deleteRef.current.click();
    }

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };

    useEffect(() => {
        if (isreRender || props.isActive) {
            fetchPhoneNumberData();
            setisreRender(false);
        }
    }, [isreRender, props.isActive]); 
    async function fetchPhoneNumberData() {
        try {
            setIsloading(true);
            setInternalError(false);

            const response = await getPhoneNumberRemediationData(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.MONITORING_LINK
            );
            setIsloading(false);
            const rawData = await response.json();

            if (response.status === 200) {
                setreputationInfo(rawData?.phMonitoring ?? []);
            } else if (response.status === 500) {
                setInternalError(true);
            } else {
                navigate("/");
            }
            await getFreePhoneNumbers();
        } catch (e) {
            console.log(`Unable to process the request: ${e}`);
            setInternalError(true);
        }
    }

    async function getFreePhoneNumbers() {
        let updates = {
            misc: ["free_dids_monitoring"],
        };

        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            updates
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const basicInfo = await response.json();
        if (!basicInfo) {
            window.alert(`info with id not found`);
            navigate("/");
        }
        console.log("response data is :::::::::: " + basicInfo);
        setSourceNumber(basicInfo.misc.free_dids);
    }

    function showThisInf(tdata) {
        navigate("/reputationsettings", {
            state: tdata.phnumInfo,
        });
    }

    const handleScreenShot = (screenshot, flaggedService) => {
        const screenshotArr = screenshot ? screenshot.split(",") : [];
        const flaggedServiceArr = flaggedService ? flaggedService.split(",") : [];

        setimageUrl(screenshotArr);
        setflagService(flaggedServiceArr);
        toggleOpen();
    }

    // Unified method for both add and remove operations
    async function handlePhoneNumberOperation(numbers, operation) {
        const updateData = {
            reqid: 159,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            [operation]: numbers,
        };

        console.log(`Phone Number ${operation} data :::`, JSON.stringify(updateData));

        setIsloading(true);
        try {
            const response = await updatePhoneNumberRemediation(updateData);
            const responseMsg = await response.json();

            console.log(`Response of ${operation} Phone Number:`, JSON.stringify(responseMsg));

            setTimeout(() => {
                setIsloading(false);
            }, 1000);

            if (responseMsg.status && responseMsg.status === "success") {
                setSuccessMessage(responseMsg.message);
                setisreRender(true); // Trigger data refresh

                // Close modals
                // if (operation === 'adddids') {
                //     togglePopup();
                // } 
                if (operation === 'removedids') {
                    toggleDeleteModal();
                }
            } else {
                setInternalError(true);
                seterrorResponse(responseMsg.message);
                // Handle errors here if needed
                console.error(`${operation} operation failed:`, responseMsg);
            }
        } catch (error) {
            console.error(`Error during ${operation} operation:`, error);
            setIsloading(false);
        }
    }

    // Handle delete confirmation
    async function handleDeleteConfirm() {
        if (deleteNumberList.length > 0) {
            await handlePhoneNumberOperation(deleteNumberList, 'removedids');
            toggleDeleteModal();
        }
    }

    // Handle add numbers
    useEffect(() => {
        if (assignPhNum.length > 0 && assignExecuted) {
            let formatedNumbers = assignPhNum.map(phNum => unFormatNumber(phNum));
            handlePhoneNumberOperation(formatedNumbers, 'adddids');
            setAssignExecuted(false);
        }
    }, [assignPhNum, assignExecuted]);

    // Delete confirmation modal content
    // const DeleteConfirmationContent = () => (
    //     <>
    //         <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3 rounded-3 square border border-2 border-danger">
    //             <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
    //             <span>{t("RemoveRemediationPhonetxt")}</span>
    //         </div>
    //         <div style={{ display: "none" }}>
    //             <button ref={deleteRef} onClick={handleDeleteConfirm}>
    //                 {t("remove")}
    //             </button>
    //         </div>
    //     </>
    // );
    useEffect(() => {
        let processdrows = [];
        reputationInfo.map((phnum) => {
            processdrows.push({
                phnumInfo: phnum,
                number: phnum.phone_number ? formattedNumber(phnum.phone_number) : "",
                actualNumber: phnum.phone_number ?? "",
                actualNum:formattedNumber(phnum.phone_number).toString().replace(/[ ]/g, ''),
                services: phnum?.flagged_service ? phnum.flagged_service + "" : "",
                screenshots: (
                    phnum?.screenshot && phnum?.screenshot !== "" ? (
                        <div className="d-flex align-items-center ms-2">
                            <div
                                className="custom-hover-bg p-1 cursor-pointer screenshotToolTip"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleScreenShot(phnum?.screenshot ?? "", phnum.flagged_service);
                                }}
                            >
                                <MDBIcon fas icon="image" color="primary" className="mx-1 fs-5" />
                            </div>
                        </div>
                    ) : ""
                ),
                lastFlagged: phnum.last_flagged ? phnum.last_flagged : "",
                addedOn: phnum?.added_on ? phnum?.added_on + "" : "",
                remove: (
                    <div className="d-flex align-items-center ms-2">
                        <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setdeleteNumberList([phnum.phone_number]);
                            toggleDeleteModal();
                        }}>
                            <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                        </div>
                    </div>
                ),
            })
        });
        setRowData(processdrows)
        setFilteredRows(processdrows)
        setDataLoaded(true)
    }, [reputationInfo])


    const tableData = {
        columns: [
            { label: 'Numbers', field: 'number' },
            { label: 'Flagged Services', field: 'services' },
            { label: 'Screenshots', field: 'screenshots', sort: false },
            { label: 'Last Flagged', field: 'lastFlagged' },
            { label: 'Added On', field: 'addedOn' },
            { label: 'Remove', field: 'remove', sort: false },
        ],
        rows: rowdata,
    }


    useEffect(() => {
        const patchTitles = () => {
            const tds = document.querySelectorAll('table td');
            tds.forEach(td => {
                const trimmed = td.textContent.trim();
                if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
                    td.setAttribute('title', trimmed);
                }
            });
        };
        patchTitles();
        const table = document.querySelector('.Reputation-Table');
        if (!table) return;
        const observer = new MutationObserver(() => {
            patchTitles();
        });
        observer.observe(table, {
            childList: true,
            subtree: true,
        });
        return () => observer.disconnect();
    }, []);



    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUsers = customSearch(rowdata, searchValue, UIConstant.REPUTATION);

        setFilteredRows(filteredUsers);
    };

    return (
        // <React.Fragment>
        //     <>
        //         <MainLinks active={2} />
        //         <Body
        //             tablinks={2}
        //             sublink={37}
        //             content={
                        <>
                            {/* <section className="mb-3"> */}
                                {/* <div className="card card-height"> */}
                                    {/* <div className="card-header py-3 px-0"> */}
                                        {/* <h5 className="mb-0 ">
                                            Reputation
                                        </h5> */}

                                        {/* <MDBCard className='p-0 col-md-5 tab-w-70 shadow-none mob-w-100 mb-0 mt-3'>
                                            <MDBCardBody className='d-flex justify-content-between align-items-center rounded bg-info bg-opacity-10'>
                                                <div>
                                                    <MDBCardTitle className='mb-0'>Monitoring and Remediation</MDBCardTitle>
                                                    Enable or disable reputation services.
                                                </div>
                                                <MDBCardText>
                                                    <div className="phoneselect">
                                                        <label className="switch">
                                                            <input className="form-control" type="checkbox" />
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </div>
                                                </MDBCardText>
                                            </MDBCardBody>
                                        </MDBCard> */}
                                    {/* </div> */}

                                    {/* <div className="card-body px-0"> */}
                                        {/* <MDBTabs className='mb-3'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                    Monitoring
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        </MDBTabs> */}

                                        {/* <MDBTabsContent>
                                            <MDBTabsPane open={basicActive === 'tab1'}> */}
                                            <div className="w-100 phonenumbersDatatable">
                                                <div className="actionbar">
                                                    <MDBBtn className="me-2" color="primary" onClick={(e) => { e.preventDefault(); togglePopup(); }}>
                                                        <i className="fas fa-plus me-2"></i> Add Number
                                                    </MDBBtn>
                                                </div>
                                                <div className='mb-2 mt-2 position-relative w-auto'>
                                                    <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                                                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                                                </div>

                                                <div className="Reputation-Table">
                                                    <MDBDatatable
                                                        hover
                                                        responsive
                                                        fixedHeader
                                                        // search
                                                        className="actioncolumn Reputation-Table"
                                                        data={{
                                                            ...tableData,
                                                            rows: filteredRows,
                                                        }}
                                                        onRowClick={(e) => showThisInf(e)}
                                                    />
                                    </div>
                                </div>
                                            {/* </MDBTabsPane>
                                        </MDBTabsContent> */}
                                    {/* </div> */}
                                {/* </div> */}
                            {/* </section> */}
                        {/* </> */}
                    {/* // }
                /> */}

                {/* Screenshot Modal */}
                <MDBModal open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-1'>
                    <MDBModalDialog className="w-max-content">
                        <MDBModalContent className="bg-transparent border-0 shadow-0 w-max-content">
                            <MDBModalBody className="p-0 bg-transparent border-0 shadow-0 w-max-content">

                                <div className="d-flex align-items-center ">
                                    {imageUrl && imageUrl
                                        .filter((img) => img && img.trim() !== "") // skip empty/invalid URLs
                                        .map((img, index) => (
                                            <img
                                                key={index}
                                                src={img}
                                                alt={`screenshot-${index}`}
                                                className="view-screenshot"
                                            />
                                        ))}

                                </div>
                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                {/* Add Numbers Modal */}
                {addNumbers && (
                    <PopupLoaderNew
                        title={t("Add Number")}
                        content={
                            <AddRemoveNumbers
                                selectedNum={existingNumbers}
                                setUpdatePHNum={setAssignPhNum}
                                setUpdateNumbersExecuted={setAssignExecuted}
                                onClose={togglePopup}
                                sourceNumber={sourceNumber}
                                ref={addNumberRef}
                                setIsloading={setisLoading}
                                reputationFlag={true}
                            />
                        }
                        onClose={togglePopup}
                        onSave={handleClick}
                        isloading={isLoading}
                        flag={1}
                    />
                )}

                {/* Delete Confirmation Modal */}
                {showDeleteModal && (
                    <PopupLoaderNew
                        title={"Remove Phone Number"}
                        content={
                            <>
                                <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3 rounded-3 square border border-2 border-danger">
                                    <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                                    <span>{t("RemoveRemediationPhonetxt")}</span>
                                </div>
                                <div style={{ display: "none" }}>
                                    <button ref={deleteRef} onClick={(e) => { e.preventDefault(); handleDeleteConfirm() }}>
                                        {t("remove")}
                                    </button>
                                </div>
                            </>
                        }
                        onClose={toggleDeleteModal}
                        onSave={handleDeleteClick}
                        isloading={isLoading}
                        flag={4}
                    />
                )}

                {/* Tooltips */}
                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Remove
                </Tooltip>
                <Tooltip anchorSelect=".screenshotToolTip" place="top" className="exampleTooltip">
                    View Screenshot
                </Tooltip>

                {/* Error Alert */}
                {internalError && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="danger"
                        autohide
                        position="bottom-right"
                        delay={5000}
                        onClose={() => setInternalError(false)}
                    >
                        {errorResponse ? errorResponse : "Internal Server Error"}
                    </MDBAlert>
                )}

                {/* Success Message */}
                {successMessage && (
                    <TopSuccess>
                        <TopMessage successMessage={successMessage} />
                    </TopSuccess>
                )}

                {/* Loading Spinner */}
                {isloading && (
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                )}
            </>
        // </React.Fragment>
    )
}

export default ReputationLanding